/**
 * Het moment van versturen, in woorden en in regels (plak 2.4).
 *
 * Eigen bestandje naast `Reactietegel.tsx` zodat de component alleen
 * een component exporteert (eslint `react-refresh/only-export-components`)
 * en deze regel los te toetsen is.
 */

/** De vier keuzes uit de tegel, in de volgorde van het ontwerp. */
export const MOMENTEN: { waarde: string; label: string }[] = [
  { waarde: "nu", label: "Nu versturen" },
  { waarde: "vandaag_17", label: "Vandaag 17:00" },
  { waarde: "morgen_08", label: "Morgen 08:00" },
  { waarde: "kies", label: "Kies tijd" },
];

/**
 * Is "Vandaag 17:00" nu nog een keuze?
 *
 * Na 17:00 weigert de backend hem met een nette fout — hij schuift
 * bewust niet stil door naar morgen. Het scherm zet de keuze dan uit
 * mét de reden erbij, in plaats van hem te laten kiezen en pas bij het
 * versturen te klappen.
 *
 * Amsterdamse kloktijd, want dat is de tijd die op het scherm staat en
 * waar de backend mee rekent. De browser van JP staat daarop, maar een
 * sessie vanaf een ander toestel hoeft dat niet te zijn.
 */
export function vandaagZeventienKan(nu: Date = new Date()): boolean {
  const uren = Number(
    nu.toLocaleString("nl-NL", {
      timeZone: "Europe/Amsterdam",
      hour: "2-digit",
      hour12: false,
    }),
  );
  return uren < 17;
}

/**
 * De keuzes die nu nog kunnen (sessie 48, B3). Een tijd die al geweest is
 * staat er niet meer tussen: "Vandaag 17:00 (al geweest)" was een keuze
 * die niets deed.
 */
export function momentenNu(nu: Date = new Date()): { waarde: string; label: string }[] {
  return MOMENTEN.filter(
    (keuze) => keuze.waarde !== "vandaag_17" || vandaagZeventienKan(nu),
  );
}

/** "2026-09-23T20:41" in Amsterdamse tijd: de vroegste eigen tijd. */
export function vroegsteEigenTijd(nu: Date = new Date()): string {
  const delen = new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Amsterdam",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).format(nu);
  return delen.replace(" ", "T");
}
